import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';

import { firebaseEmulatorConfig } from '@/src/config/env';
import { firebaseApp } from '@/src/lib/firebase';

export const functions = getFunctions(firebaseApp, 'us-central1');

if (firebaseEmulatorConfig.enabled) {
  connectFunctionsEmulator(
    functions,
    firebaseEmulatorConfig.host,
    firebaseEmulatorConfig.ports.functions,
  );
}
